import { Selection } from 'd3';
import { SvgCtrParams } from '../types';
import Margin from './margin';
import Utils from '../Utils';

export default class Svg {
  elementId: string;
  d3Svg: Selection<SVGGElement, unknown, HTMLElement, any>;
  height = 100;
  width = 100;
  margin: Margin;
  transform: string;

  constructor(params?: SvgCtrParams) {
    if (params?.elementId) this.elementId = params.elementId;
    if (params?.margin) this.margin = params.margin;
    if (params?.height) this.height = params.height;
    if (params?.width) this.width = params.width;
    if (params?.transform) this.transform = params.transform;
  }

  public draw() {
    const { height, width, margin, transform } = this;
    const opts = { height, width, margin, transform };
    this.d3Svg = Utils.drawSvg(this.elementId, opts);
  }

  public destroy() {
    if (this.d3Svg) this.d3Svg.remove();
  }
}
